import * as React from 'react';
import { connect } from 'react-redux';
import { select } from '@rematch/select';
import { Trans, withTranslation } from 'react-i18next';

import { Icon } from '../../atoms/icon';
import { Loader } from '../../atoms/loader';
import { ProfileSideNav } from './ProfileSideNav';
import { Menu, MenuButton, MenuList, MenuItem } from '../../atoms/menu';
import { UserZoneLayout } from '../../layouts/UserZoneLayout';
import { can } from '../../utils/permissions';

export class UserJoinedCommunitiesRenderer extends React.Component {
  leaveCommunity = (community) => {
    if (window.confirm(this.props.t('Do you really want to leave this community?'))) {
      this.props.leaveCommunity(community);
    }
  };

  componentDidMount() {
    this.props.getJoinedCommunities();
  }

  renderCommunityRow = (community) => (
    <div key={community.id} className="user-joined-communities__row">
      {community.organization.profile_photo ? (
        <div
          className="user-joined-communities__row__photo"
          style={{ backgroundImage: `url(${community.organization.profile_photo.url})` }}
        />
      ) : null}
      <span className="user-joined-communities__row__name">{community.name}</span>
      {can(community, 'Community', 'leaveCommunity') && (
        <Menu>
          <MenuButton className="user-joined-communities__row__icon">
            <Icon name="menu" />
          </MenuButton>
          <MenuList>
            <MenuItem onSelect={() => this.leaveCommunity(community)}>
              <Trans>Leave community</Trans>
            </MenuItem>
          </MenuList>
        </Menu>
      )}
    </div>
  );

  render() {
    return (
      <UserZoneLayout navigation={<ProfileSideNav user={this.props.user} />}>
        <div className="user-joined-communities" id="profile-joined-communities">
          {this.props.loadingCommunity && <Loader />}
          {this.props.communitiesGroupedByOrganization.map(([organization, communities]) => (
            <React.Fragment key={organization.id}>
              <div className="user-joined-communities__name">{organization.name}</div>
              {communities.map(this.renderCommunityRow)}
            </React.Fragment>
          ))}
        </div>
      </UserZoneLayout>
    );
  }
}

const mapState = (state) => ({
  user: select.session.user(state),
  loadingCommunity: state.loading.effects.communities.joinedAsync,
  communitiesGroupedByOrganization: select.communities.groupBy(state, 'organization'),
});

const mapDispatch = (dispatch) => ({
  getJoinedCommunities: () => dispatch.communities.joinedAsync(),
  leaveCommunity: (community) => dispatch.communities.unjoinAsync(community),
});

export const UserJoinedCommunities = withTranslation()(connect(mapState, mapDispatch)(UserJoinedCommunitiesRenderer));
